import ContributionPeriod from "@/models/api/contributionPeriod/ContributionPeriod";
import axios, { AxiosResponse } from "axios";
import SelectListItem from '../models/SelectListItem';

class Service {
    public async GetSelectListItems(): Promise<AxiosResponse<SelectListItem[]>> {
        return axios.get('api/contributionPeriod/GetSelectListItems');
    }
    public async GetRegistrationSelectListItems(): Promise<AxiosResponse<SelectListItem[]>> {
        return axios.get('api/contributionPeriod/GetRegistrationSelectListItems');
    }



    public async GetContributionPeriods(): Promise<AxiosResponse<ContributionPeriod[]>> {
        return axios.get('api/contributionPeriod/');
    }
    public async GetContributionPeriod(id: number): Promise<AxiosResponse<ContributionPeriod>> {
        return axios.get(`api/contributionPeriod/${id}`);
    }
    public async SaveContributionPeriod(data: ContributionPeriod): Promise<AxiosResponse<any>> {
        return axios.post("api/contributionPeriod/", data);
    }
    public async RemoveContributionPeriod(id: number): Promise<AxiosResponse<any>> {
        return axios.delete(`api/contributionPeriod/${id}`);
    }
}

export const ContributionPeriodService: Service = new Service();
